import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {bzIconCheck, bzIconEditOutline} from '@bringoz/ui/icons';
import {TimeCardGroupStatus} from '../../models/timecard-group.model';
import {BranchReference} from '../../models/timecard.model';
import {TimecardAggregatedData, TimecardEmployee} from '../../models/timecard-detail.model';

/** One-row summary of the agent's day. */
require('./timecard-detail-summary.scss');
@Component({
  standalone: false,
  selector: 'app-timecard-detail-summary',
  templateUrl: './timecard-detail-summary.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecardDetailSummaryComponent {

  readonly employee = input<TimecardEmployee>();
  readonly groupStatus = input<TimeCardGroupStatus | null>(null);
  readonly branchReferences = input<BranchReference[]>([]);
  readonly aggregatedData = input<TimecardAggregatedData>();
  readonly canEditAdminTime = input<boolean>(false);

  readonly editAdminTime = output<void>();

  readonly icons = {edit: bzIconEditOutline, check: bzIconCheck};

  onAdminTimeClick(event: MouseEvent) {
    event.stopPropagation();
    if (this.canEditAdminTime()) {
      this.editAdminTime.emit();
    }
  }
}
